<i18n src="./langs.yaml"></i18n>
<template>
  <section class="container">
    <div v-for="(item, key) in getContents()" :key="key" class="block">
      <div class="title">{{ item.title }}</div>
      <div v-if="AREA.toLocaleUpperCase() === 'US' && item.US" class="content">
        <div v-for="(pa, i) in item.US" :key="i" class="paragraph">
          {{ pa }}
        </div>
      </div>
      <div v-else-if="item.paragraphs" class="content">
        <div v-for="(pa, i) in item.paragraphs" :key="i" class="paragraph">
          {{ pa }}
        </div>
      </div>
      <div v-else class="content">
        <div v-for="(tx, i) in item.texts" :key="i" class="text">
          {{ tx }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Rule',
  computed: {
    ...mapState(['AREA', 'LANG']),
  },
  methods: {
    getContents() {
      // @ts-ignore
      let contents = this.$t('contents')
      if (this.LANG === 'en' || this.LANG === 'zh-TW' || this.LANG === 'ko') {
        const res = this.$t(`contents${this.AREA}`)
        if (res && res !== `contents${this.AREA}`) {
          contents = res
        }
      }
      return contents
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 750px;
  position: relative;
  padding: 64px 40px 0px;
  .block {
    margin-bottom: 80px;
    text-align: justify;
    .title {
      color: rgb(0, 0, 0);
      font-family: PingFangSC-Medium;
      font-size: 36px;
      font-weight: 500;
      text-align: left;
    }
    .content {
      margin-top: 16px;
      color: rgb(20, 21, 26);
      font-family: PingFangSC-Regular;
      font-size: 26px;
      font-weight: normal;
      .paragraph {
        line-height: 48px;
      }
      .paragraph + .paragraph {
        margin-top: 32px;
      }
      .text {
        line-height: 48px;
      }
    }
  }
}
</style>
